/** @jsx jsx */
import { jsx } from 'theme-ui'
import { FC } from 'react'
import { FeaturedCollectionType, HeroHeader, Maybe } from '~/@types/models'
import CollectionLinks from '~/components/collections-header/featured-collection-links'
import SimpleContent from './simple-content'
import { FeaturedCollectionInterface } from './types'

interface Props {
  title: string
  description?: string
  heroHeader?: Maybe<HeroHeader>
  showFeaturedCollections?: boolean
  handle?: string
  featuredCollectionsList?: FeaturedCollectionType[]
  headerDescription?: string
}

const CollectionsHeader: FC<Props> = ({
  title,
  handle,
  showFeaturedCollections,
  featuredCollectionsList,
  headerDescription,
}) => {
  if (showFeaturedCollections) {
    return (
      <CollectionLinks
        title={title}
        handle={handle}
        featuredCollectionsList={featuredCollectionsList}
        headerDescription={headerDescription}
      />
    )
  } else {
    return <SimpleContent title={title} description={headerDescription} />
  }
}

export default CollectionsHeader
